<template>
  <div v-if="loading">
    <Spinner/>
  </div>
  <div v-else-if="user" class="text-sm grid grid-cols-10 pb-10 gap-10">
    <div class="col-span-10 md:col-span-8">
      <div class="grid grid-cols-6 gap-2">
        <div class="col-span-6 sm:col-span-3">
          <label class="g--label mb-1">Full name</label>
          <input type="text" v-model="user.fullName" class="g--input">
        </div>
        <div class="col-span-6">
          <div class="g--label mt-4 mb-2">Email address</div>
          <div class="text-sm">{{ user.email }}</div>
          <div class="flex mt-2 items-center gap-2 flex-wrap">
            <a href="/change-email" class=" g--button text-sm">Change your email address</a>
            <a href="/change-password" class="  g--button text-sm">Change your password</a>
          </div>


          <div class="mt-6">
            <div class="flex items-start">
              <div class="flex items-center h-5"><input type="hidden" name="fields[subscribedToWeeklyEmails]" value="">
                <input v-model="user.subscribedToWeeklyEmails" id="subscribedToWeeklyEmails"
                       name="fields[subscribedToWeeklyEmails]"
                       type="checkbox"
                       class="cursor-pointer form-checkbox h-4 w-4 text-teal transition duration-150 ease-in-out"></div>
              <div class="ml-3 text-sm leading-5">
                <label for="subscribedToWeeklyEmails" class="cursor-pointer font-medium text-gray-700">
                  Receive the weekly upcoming classes email.</label>
              </div>
            </div>
          </div>
        </div>
        <div class="col-span-6 sm:col-span-3">
          <button class="mt-10 g--button w-full" :class="{
                  'g--button--green': !isSaving,
                  'g--button--gray opacity-75 cursor-not-allowed': isSaving
                }" :disabled="isSaving" @click="saveProfile">
            {{ saveButtonText }}
          </button>
        </div>
      </div>
      <div class="grid grid-cols-6 gap-2">
        <div class="col-span-6 sm:col-span-3">
          <div class="mt-6">
            <div class="g--label mt-4 mb-2">Privacy</div>
            <p class="text-sm  mt-2 italic">Teachers you take classes
              with can see your full name and email address.</p>
            <p class="text-sm  mt-2 italic">Note on Zoom: your screen name will appear to the teacher and the other
              students during the class.</p>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import Spinner from './Spinner.vue';
import Editor from './Editor.vue'
import Tooltip from './Tooltip.vue'


const loading = ref(true);
const user = ref(null);
const saveButtonText = ref('Save changes');
const isSaving = ref(false);


onMounted(() => {
  loadUser();
});

const loadUser = async () => {
  const response = await fetch(`/api/students/self`);
  user.value = await response.json();
  console.log(user.value);
  loading.value = false;
};


const saveProfile = async () => {
  console.log(user.value.allStyles);
  isSaving.value = true;
  saveButtonText.value = 'Saving...';
  const formData = new FormData();
  formData.append('fullName', user.value.fullName);
  formData.append('fields[subscribedToWeeklyEmails]', user.value.subscribedToWeeklyEmails ? 1 : 0);

  formData.append('userId', user.value.userId);
  formData.append(csrfTokenName, csrfTokenValue);

  fetch('?action=users/save-user', {
    method: 'post',
    headers: {
      'Accept': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: formData
  })
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        console.log(response);
        saveButtonText.value = 'Saved!';
        setTimeout(() => {
          saveButtonText.value = 'Save changes';
          isSaving.value = false;
        }, 2000);
      })
      .catch((error) => {
        console.error('Error saving profile:', error);
        saveButtonText.value = 'Save changes';
        isSaving.value = false;
      });
};
</script>